<script>
import MainLayout from '../layouts/mainLayout'
import {RoleFlagCheck} from '@/utils/RoleFlagCheck.js'
import {DateUtil} from '@/utils/date.js'
import dialog from '@/components/Dialog'
import showMap from '@/components/showMapWindowMask'
import mapDropPin from '../../assets/map_icon/map_drop_pin.png'
export default {
  components: {MainLayout, 'v-dialog': dialog, showMap},
  data () {
    return {
      userInfoDetail: '',
      isMasterManager: false,
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: 'このアカウントを消去します<br/>よろしいですか?',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      sendShowDialog: false,
      sendDialogOption: {
        showNo: false,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      }
    }
  },

  created () {
    this.userInfoDetail = JSON.parse(sessionStorage.getItem('userInfoDetail'))
    let loginRoleFlag = sessionStorage.getItem('currentUserRoleFlag')
    this.isMasterManager = RoleFlagCheck.masterManager(loginRoleFlag)
  },
  methods: {
    // 返回アカウントリスト主画面
    goback () {
      this.$router.push({ name: 'MemberList' })
    },
    // roleFlags (roleFlag) {
    //   return RoleFlagCheck.roles(roleFlag)
    // },
    // 会员管理者判断
    memberCheck (roleFlag) {
      return RoleFlagCheck.member(roleFlag)
    },
    // 司机管理者判断
    driverCheck (roleFlag) {
      return RoleFlagCheck.diver(roleFlag)
    },
    // 一般管理者判断
    generalManagerCheck (roleFlag) {
      return RoleFlagCheck.generalManager(roleFlag)
    },
    // master管理者判断
    masterManagerCheck (roleFlag) {
      return RoleFlagCheck.masterManager(roleFlag)
    },
    // 用于判断权限显示中会员（flag=1）和司机权限(flag=2)后有无其后的权限
    managerCheck (roleFlag, flag) {
      if (flag === 1) {
        return RoleFlagCheck.diver(roleFlag) || RoleFlagCheck.generalManager(roleFlag) || RoleFlagCheck.masterManager(roleFlag)
      }
      if (flag === 2) {
        return RoleFlagCheck.generalManager(roleFlag) || RoleFlagCheck.masterManager(roleFlag)
      }
    },
    // 交通事業者判断
    transportCheck (roleFlag) {
      return RoleFlagCheck.transport(roleFlag)
    },
    // 转化性別显示
    sexCheck (sex) {
      if (sex === 0) {
        return '男'
      } else if (sex === 1) {
        return '女'
      } else { return '' }
    },
    // 计算年龄（yyyyMMdd变换成--岁）
    ageCheck (day) {
      return DateUtil.yearCompute(day)
    },
    // 日期转化（yyyyMMdd变换成yyyy年MM月dd日）
    convertDate (date) {
      return DateUtil.yearMonthDay(date)
    },
    // 车龄计算（yyyyMMdd变换成--年--月）
    driverAgeCheck (day) {
      return DateUtil.yearMonthCompute(day)
    },
    // 删除アカウント信息(??????)
    deleteUser () {
      // if (this.isMasterManager) {
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        let param = this.$qs.stringify({userId: this.userInfoDetail.uid})
        this.$axios.post('user/deleteUserByUid', param)
          .then(response => {
            this.$router.push({ name: 'MemberList' })
          })
          .catch((error) => {
            console.log(error)
          })
        this.showDialog = false
      }).catch(() => {
        this.showDialog = false
      })
      // } else {
      //   this.$router.push({ name: 'MemberList' })
      // }
    },
    // 地图显示自宅住址
    map (homeLat, homeLng, homeAddress) {
      homeLat = parseFloat(homeLat)
      homeLng = parseFloat(homeLng)
      this.$refs.showMapWindow.mapTitle = '自宅住所：' + homeAddress

      if ((Math.abs(homeLat) >= 0.0000000000000001) || (Math.abs(homeLng) >= 0.0000000000000001)) {
        // 图标样式
        let vehiclePoint = {
          lat: homeLat,
          lng: homeLng,
          icon: mapDropPin
        }
        var centerPoint = {
          lat: homeLat,
          lng: homeLng
        }
        this.$refs.showMapWindow.centerPoint = centerPoint
        this.$refs.showMapWindow.markPosition = vehiclePoint
      }

      this.$refs.showMapWindow.initiGoogleMap()
    },
    // 编辑用户信息
    editorUser () {
      this.$router.push({ name: 'UserEditor' })
    },
    // 通过手机号码发送ID和密码短信
    sendMessage () {
      if (this.userInfoDetail.portableTelephone === null || this.userInfoDetail.portableTelephone.length === 0) {
        this.showMessageBox('携帯電話番号が入力されていません。ご確認ください。')
      } else {
        let param = this.$qs.stringify({portableTelephone: this.userInfoDetail.portableTelephone, loginId: this.userInfoDetail.loginId, password: this.userInfoDetail.password})
        this.$axios.post('user/sendMessage', param)
          .then(response => {
            this.showMessageBox('ID・パスワードを送信しました。')
            // alert('成功を送る')
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    // message dialog
    showMessageBox (title, yesNoFlag, yesText, noText) {
      this.sendDialogOption.text = title
      this.sendDialogOption.showNo = yesNoFlag
      this.sendDialogOption.confirmButtonText = yesText
      this.sendDialogOption.cancelButtonText = noText
      this.sendShowDialog = true
      this.$refs.sendDialog
        .confirm()
        .then(() => {
          this.sendShowDialog = false
        })
        .catch(() => {
          this.sendShowDialog = false
        })
    }
  }
}
</script>

<template>
  <main-layout>
    <div class="col-md-12 column" style="width:100%;display:flex;flex-direction: column;flex:1">
      <div class="row clearfix" style="flex:0 0 40px;position: relative;margin-top: 20px;">
        <div class="col-md-7 column headermiddle" style="position: absolute;width: 100%;">
          アカウント詳細
        </div>
        <div class="col-md-2 column headerleft F1-R-19" style="vertical-align: bottom">
          <input type="button" value="会員リストに戻る" @click="goback" />
        </div>
      </div>
      <div class="row clearfix tablediv scrollbar" style="flex: 1;">
        <table class="table table-bordered window-table">
          <tbody>
            <tr>
              <td class="td-key td-key-Width">
                ユーザーID
              </td>
              <td class="td-value td-value-Width">
                {{userInfoDetail.loginId}}
              </td>
              <td class="td-key td-key-Width" v-show=this.isMasterManager>
                パスワード
              </td>
              <td class="td-value td-value-Width" v-show=this.isMasterManager>
                {{userInfoDetail.password}}
              </td>
            </tr>
            <tr style="height:18px;">
              <!-- <td colspan="4" style="border-top:2px solid red"></td> -->
            </tr>
            <tr>
              <td class="td-key td-key-Width" style="border-top:2px solid rgb(148, 148, 148)">
                権限
              </td>
              <td colspan="3" class="td-value" style="border-top:2px solid rgb(148, 148, 148)">
                <div style="display:flex;flex-direction: row;height: 30px;">
                  <div style="width:100px;height: 30px;" v-show="memberCheck(userInfoDetail.roleFlag)">
                    <img src="../../assets/icon/member_status1.png" style="height: 25px;width:25px;">
                    <span>会員</span>
                    <span v-show="managerCheck(userInfoDetail.roleFlag,1)">、</span>
                  </div>
                  <div style="width:150px;height: 30px;" v-show="driverCheck(userInfoDetail.roleFlag)">
                    <img src="../../assets/icon/member_status2.png" style="height: 25px;width:25px;">
                    <span>ドライバー</span>
                    <span v-show="managerCheck(userInfoDetail.roleFlag,2)">、</span>
                  </div>
                  <div style="width:150px;height: 30px;" v-show="generalManagerCheck(userInfoDetail.roleFlag)">
                    <img src="../../assets/icon/member_status3.png" style="height: 25px;width:25px;">
                    <span>一般管理者</span>
                    <span v-show="masterManagerCheck(userInfoDetail.roleFlag)">、</span>
                  </div>
                  <div style="width:150px;height: 30px;" v-show="masterManagerCheck(userInfoDetail.roleFlag)">
                    <img src="../../assets/icon/member_status4.png" style="height: 25px;width:25px;">
                    <span>管理マスター</span>
                  </div>
                  <div style="width:150px;height: 30px;" v-show="transportCheck(userInfoDetail.roleFlag)">
                    <img src="../../assets/icon/member_status5.png" style="height: 25px;width:25px;">
                    <span>交通事業者</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                フリガナ
              </td>
              <td class="td-value td-value-Width member-name" :title="userInfoDetail.lastNamekana+userInfoDetail.firstNamekana">
                {{userInfoDetail.lastNamekana+userInfoDetail.firstNamekana}}
              </td>
              <td class="td-key td-key-Width">
                生年月日
              </td>
              <td class="td-value td-value-Width">
                {{convertDate(userInfoDetail.birthday)}}
              </td>

            </tr>
            <tr>
              <td class="td-key td-key-Width">
                氏名
              </td>
              <td class="td-value td-value-Width member-name" :title="userInfoDetail.lastName+' '+userInfoDetail.firstName">
                {{userInfoDetail.lastName+' '+userInfoDetail.firstName}}
              </td>
              <td class="td-key td-key-Width">
                年齢
              </td>
              <td class="td-value td-value-Width">
                {{ageCheck(userInfoDetail.birthday)}} 才
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                性別
              </td>
              <td class="td-value td-value-Width">
                {{sexCheck(userInfoDetail.sex)}}性
              </td>
              <td class="td-key td-key-Width">
                登録日
              </td>
              <td class="td-value td-value-Width">
                {{convertDate(userInfoDetail.joinDate)}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                郵便番号
              </td>
              <td colspan="3" class="td-value">
                {{userInfoDetail.postalcode}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                自宅住所
              </td>
              <td colspan="3" class="td-value">
                <div class="row clearfix">
                  <div class="col-md-8 column"> {{userInfoDetail.homeAddress}}</div>
                  <div class="col-md-4 column">
                    <a href="#modal-container-staySave" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                      <button class="mapbtn F2-M-15 detailed-button" @click="map(userInfoDetail.homeLat, userInfoDetail.homeLng,userInfoDetail.homeAddress)" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                        マップ
                      </button>
                    </a>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                電話番号
              </td>
              <td colspan="3" class="td-value">
                {{userInfoDetail.homeTelephone}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Widt">
                携帯番号
              </td>
              <td colspan="3" class="td-value">
                {{userInfoDetail.portableTelephone}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                FAX
              </td>
              <td colspan="3" class="td-value">
                {{userInfoDetail.fax}}
              </td>
            </tr>
            <tr v-show="memberCheck(userInfoDetail.roleFlag)">
              <td class="td-key td-key-Width">
                料金
              </td>
              <td colspan="3" class="td-value">
                {{userInfoDetail.passengerCost}} <span v-show="userInfoDetail.passengerCost!==''&&userInfoDetail.passengerCost!=null">円</span>
              </td>
            </tr>
            <tr>
              <td class="td-key" style="width:13%;text-align: center;line-height:90px">
                備考
              </td>
              <td colspan="3" class="td-value word-breaker">
                <!-- <textarea class="rowtextarea" rows="3" v-model="remarks"></textarea> -->
                {{userInfoDetail.note}}
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-bordered window-table" v-show="driverCheck(userInfoDetail.roleFlag)">
          <tbody>
            <tr>
              <td colspan="3" class="bgc3 F2-M-19">
                ドライバー項目
              </td>
            </tr>
            <tr>
              <td width='18%' rowspan="8" class="td-value">
                <!--  有数据时替换成userInfoDetail中对应的司机头像url-->
                <!-- <img :src="userInfoDetail.facePhotoUrl"
                  width='200px' height='280px' /> -->
                  <div class="img-bg1">
                    <img v-show="userInfoDetail.facePhotoUrl" :src="userInfoDetail.facePhotoUrl" class="img-style"/>
                    <div v-show="!userInfoDetail.facePhotoUrl" class="bgc10 F2-M-18">No Image</div>
                  </div>
              </td>
              <td class="td-key td-key-Width">
                免許証有効期限
              </td>
              <td width='69%' class="td-value">
                {{convertDate(userInfoDetail.driverLicenseDeadline)}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                ドライバー登録日
              </td>
              <td class="td-value td-driver-value">
                {{convertDate(userInfoDetail.driverJoinDate)}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                活動年数
              </td>
              <td class="td-value td-driver-value">
                {{driverAgeCheck(userInfoDetail.driverJoinDate)}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                事故歴
              </td>
              <td class="td-value td-driver-value">
                {{userInfoDetail.accidentFlag === 0?'なし':'あり'}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                事故内容
              </td>
              <td class="td-value td-driver-value">
                {{userInfoDetail.accidentFlag === 0? '' : userInfoDetail.accidentDetails}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                行政処分
              </td>
              <td class="td-value td-driver-value">
                {{userInfoDetail.sanctionFlag ===0 ?'なし':'あり'}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                処分内容
              </td>
              <td class="td-value td-driver-value">
                {{userInfoDetail.sanctionFlag === 0? '' : userInfoDetail.sanctionDetails}}
              </td>
            </tr>
            <tr>
              <td class="td-key td-key-Width">
                報酬対象
              </td>
              <td class="td-value td-driver-value">
                {{userInfoDetail.rewardFlag ===0 ?'なし':'あり'}}
              </td>
            </tr>
            <!-- 有数据时替换成userInfoDetail中对应的司机驾照url -->
            <tr>
              <td colspan='3' style="text-align:left">
                <!-- <img :src="userInfoDetail.driverLicensePhotoUrl1"
                  width='300px' margin-left='20px' height='280px' />
                <img :src="userInfoDetail.driverLicensePhotoUrl2"
                  width='300px' height='280px' /> -->
                  <div class="rowSty">
                    <div class="img-bg2">
                        <img v-show="userInfoDetail.driverLicensePhotoUrl1" :src="userInfoDetail.driverLicensePhotoUrl1" class="img-style"/>
                        <div v-show="!userInfoDetail.driverLicensePhotoUrl1" class="bgc10 F2-M-18">No Image</div>
                    </div>
                    <div class="img-bg2">
                        <img v-show="userInfoDetail.driverLicensePhotoUrl2" :src="userInfoDetail.driverLicensePhotoUrl2" class="img-style"/>
                        <div v-show="!userInfoDetail.driverLicensePhotoUrl2" class="bgc10 F2-M-18">No Image</div>
                    </div>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-bordered window-table" v-show="transportCheck(userInfoDetail.roleFlag)">
          <tbody>
            <tr>
              <td colspan="3" class="bgc3 F2-M-19">
                交通事業者項目
              </td>
            </tr>
            <tr>
              <td class="td_title  F3-R-15">交通事業者</td>
              <td class="td_test F3-M-18">{{userInfoDetail.transportName}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row clearfix" style="margin-bottom: 10px;">
        <div class="col-md-4 column delete-div" style=" justify-content: flex-end" v-if="isMasterManager">
          <button class="window-button delete-btn" @click="editorUser">編集</button>
        </div>

        <div  :class="{'col-md-4 column delete-div':isMasterManager,'col-md-12 column delete-div':isMasterManager===false}"  style=" justify-content: center" v-if="isMasterManager">
          <button class="window-button delete-btn" @click="deleteUser">このアカウントを消去</button>
        </div>
        <div class="col-md-4 column delete-div" style=" justify-content: flex-start" v-if="isMasterManager">
          <button class="window-button delete-btn" @click="sendMessage">ID・パスワードを送信</button>
        </div>
      </div>
      <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
       <v-dialog v-show="sendShowDialog" :dialog-option="sendDialogOption" ref="sendDialog"></v-dialog>
    </div>
    <showMap ref="showMapWindow"></showMap>
  </main-layout>
  <!-- 传参数传  item  -->
</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
@import '../../assets/css/globalStyle02.scss';
.headerleft {
  margin-left: 13px;
  width: 250px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  height: 40px;
  text-align: left;
  width: 100%;
  text-indent: 30px;
}
.headermiddle {
  height: 40px;
  font-size: 24px;
}
.tablediv {
//   height: 60vh;//600px
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-left: 10px;
  margin-top: 10px;
}
.window-table{
  font-size: 18px;
  border: 2px solid rgb(148, 148, 148);
  width: 99.8%;
 }
.table-bordered>tbody>tr>td{
  border: 1px solid rgb(148, 148, 148);
}
.td-title{
  background-color: #797979;
  color: #fff;
  font-size: 22px;
}
.td-key{
   // F3-R-15
  font-family: 'Noto Sans CJK JP';
  color: rgb(80, 80, 80);
  font-size: 15px ;
  font-weight: 400 ;
  background: $bgc8
}
.table>tbody>tr>td{
  padding:9px;
}
.table>tbody>tr>.td-value{
  padding-left: 30px;
}
.td-value{
  text-align: left;
  border: 1px solid #959595;
  // F3-M-18
  font-family: 'Noto Sans CJK JP';
  color: rgb(80, 80, 80);
  font-size: 18px;
  font-weight: 500;
  background: $bgc7
}

  //统一的地图按钮样式
  .mapbtn{
  height: 30px;
  width: 80px;
  font-size: 18px;
  border: none;
  background-color: #DDDDDD;
  border-radius: 4px;
  float: right;
  margin-right: 0.5%;
  color:black;
}
.rowtextarea{
  font-size: 2em;
  margin-top: 10px;
  width: 118%;
  border: 2px solid rgb(220, 220, 220);
  height: 300px;
}
.delete-div{
  display :flex;
  flex-direction:row
}
.delete-btn{
  width:350px;
  margin-top: 13px
}
.td-key-Width{
    width: 13%
}
.td-value-Width{
    width: 37%
}
.td-driver-value{
    width: 67%
}

.twoButtonWidth{
  width: 50%
}
.threeButtonWidth{
  width: 30%;
}
.member-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.img-bg1{
  color: #fff;
  width:  200px;
  height: 280px;
  line-height: 280px;
  text-align: center
}
.img-bg2{
  color: #fff;
  width:  400px;
  height: 280px;
  line-height: 280px;
  text-align: center
}
.img-style{
  height: 100%;
  width: 100%;
}
.rowSty {
  display: flex;
  & >div {
    margin: 0 20px;
  }
}
.word-breaker{
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/router/views/MemberList_Detail.vue